<template>
  <div>
    <div class="w-100" style="margin-top: -85px; position: absolute;">
      <h1 class="text-center" style="color: white">Rapport des anomalies {{ current_year }}</h1>
    </div>
    <div class="row mb-4">
      <!-- Coût des anomalies pour l'année précédente -->
      <div class="col-lg-3">
        <div class="card text-center">
          <div class="card-header">
            <h3 class="fs-5 mb-0">Coût des anomalies en {{ previous_year }}</h3>
          </div>
          <div class="card-body">
            <animated-number class="font-weight-bold mb-0" style="font-size: 30px" :value="cost_previous_year"></animated-number>
            <span class="ml-2" style="font-size: 30px">€</span>
          </div>
        </div>
      </div>

      <!-- Coût des anomalies pour l'année en cours -->
      <div class="col-lg-3">
        <div class="card text-center">
          <div class="card-header">
            <h3 class="fs-5 mb-0">Coût des anomalies en {{ current_year }}</h3>
          </div>
          <div class="card-body">
            <animated-number class="font-weight-bold mb-0" style="font-size: 30px" :value="cost_current_year"></animated-number>
            <span class="ml-2" style="font-size: 30px">€</span>
          </div>
        </div>
      </div>

      <!-- Nombre d'anomalies ouvertes -->
      <div class="col-lg-3">
        <div class="card text-center">
          <div class="card-header">
            <h3 class="fs-5 mb-0">Anomalies ouvertes</h3>
          </div>
          <div class="card-body">
            <animated-number class="font-weight-bold mb-0" style="font-size: 30px" :value="open_anomalies_count"></animated-number>
          </div>
        </div>
      </div>

      <!-- Nombre d'anomalies clôturées -->
      <div class="col-lg-3">
        <div class="card text-center">
          <div class="card-header">
            <h3 class="fs-5 mb-0">Anomalies clôturées</h3>
          </div>
          <div class="card-body">
            <animated-number class="font-weight-bold mb-0" style="font-size: 30px" :value="closed_anomalies_count"></animated-number>
          </div>
        </div>
      </div>

      <!-- Graphique du nombre d'anomalies par mois -->
      <div class="col-lg-6">
        <div class="card" style="height: 357px;">
          <div class="card-header">
            <h3 class="fs-5 text-center mb-0">Nombre d'anomalies par mois</h3>
          </div>
          <div class="card-body">
            <BarChart v-if="charts.anomaly.data.length > 0" ref="chartReference" :labels="charts.anomaly.labels"
                      :data="charts.anomaly.data" :color="charts.anomaly.color"
                      :extraOptions="charts.anomaly.chartOptions" :height="300">
            </BarChart>
          </div>
        </div>
      </div>

      <!-- Liste des anomalies ouvertes depuis plus de 3 mois -->
      <div class="col-lg-6">
        <div class="card" style="height: 357px">
          <div class="card-header">
            <h3 class="fs-5 text-center mb-0">Anomalies ouvertes depuis plus de 3 mois</h3>
          </div>
          <div class="card-body" style="height: 314px; overflow: auto;">
            <div v-if="open_anomalies_over_three_months.length > 0">
              <div class="row">
                <div class="col-12 col-md-6" v-for="(anomaly, index) in open_anomalies_over_three_months" :key="anomaly.id">
                  <div class="card mb-2" style="border: 1px solid lightgrey">
                    <div class="card-body p-2">
                      <p class="mb-1"><strong>Numéro :</strong> {{ anomaly.num }}</p>
                      <p class="mb-1"><strong>Date de création :</strong> {{ formatDate(anomaly.created_at) }}</p>
                      <p class="mb-1"><strong>Article :</strong> {{ anomaly.article_name }}</p>
                      <p class="mb-1"><strong>Client :</strong> {{ anomaly.customer_name }}</p>
                      <!-- Ajoutez d'autres informations si nécessaire -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="h-100 d-flex justify-content-center align-items-center" style="color: lightgrey; font-size: 20px">
              <i class="fas fa-wind mr-2"></i>
              <p class="mb-0">Aucune anomalie ouverte depuis plus de 3 mois.</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Les 5 articles avec le plus d'anomalies -->
      <div class="col-lg-6">
        <div class="card" style="min-height: 357px">
          <div class="card-header">
            <h3 class="fs-5 text-center">Les 5 articles avec le plus d'anomalies</h3>
          </div>
          <div class="card-body" style="height: 314px; overflow: auto;">
            <div v-if="top_articles.length > 0">
              <div class="card mb-2" style="border: 1px solid lightgrey" v-for="(article, index) in top_articles" :key="index">
                <div class="card-body d-flex align-items-center command-item">
                  <i v-if="index === 0" class="fas fa-medal mr-2" style="color: goldenrod"></i>
                  <i v-if="index === 1" class="fas fa-medal mr-2" style="color: silver"></i>
                  <i v-if="index === 2" class="fas fa-medal mr-2" style="color: #a26f21"></i>
                  <div class="d-flex justify-content-between w-100">
                    <p class="mb-0">{{ article.article_name }}</p>
                    <div class="d-flex">
                      <p class="mb-0 mr-5">{{ article.anomaly_count }} anomalies</p>
                      <p class="mb-0 d-flex justify-content-end" style="width: 100px">{{ article.total_cost ? article.total_cost : '0' }} €</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="h-100 d-flex justify-content-center align-items-center" style="color: lightgrey; font-size: 20px">
              <i class="fas fa-wind mr-2"></i>
              <p class="mb-0">Aucune données.</p>
            </div>

          </div>
        </div>
      </div>

      <!-- Les 5 clients avec le plus d'anomalies -->
      <div class="col-lg-6">
        <div class="card" style="min-height: 357px">
          <div class="card-header">
            <h3 class="fs-5 text-center">Les 5 clients avec le plus d'anomalies</h3>
          </div>
          <div class="card-body" style="height: 314px; overflow: auto;">
            <div v-if="top_clients > 0">
              <div class="card mb-2" style="border: 1px solid lightgrey" v-for="(client, index) in top_clients" :key="index">
                <div class="card-body d-flex align-items-center command-item">
                  <i v-if="index === 0" class="fas fa-medal mr-2" style="color: goldenrod"></i>
                  <i v-if="index === 1" class="fas fa-medal mr-2" style="color: silver"></i>
                  <i v-if="index === 2" class="fas fa-medal mr-2" style="color: #a26f21"></i>
                  <div class="d-flex justify-content-between w-100">
                    <p class="mb-0">{{ client.customer_name }}</p>
                    <div class="d-flex">
                      <p class="mb-0 mr-5">{{ client.anomaly_count }} anomalies</p>
                      <p class="mb-0 d-flex justify-content-end" style="width: 100px">{{ client.total_cost ? client.total_cost : '0' }} €</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="h-100 d-flex justify-content-center align-items-center" style="color: lightgrey; font-size: 20px">
              <i class="fas fa-wind mr-2"></i>
              <p class="mb-0">Aucune données.</p>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { AnimatedNumber } from "src/components";

import BarChart from "src/components/Charts/BarChart";
import moment from "moment";

export default {
  components: {
    AnimatedNumber,
    BarChart,
  },
  data() {
    const currentYear = new Date().getFullYear();
    return {
      current_year: currentYear,
      previous_year: currentYear - 1,
      cost_previous_year: 0,
      cost_current_year: 0,
      open_anomalies_count: 0,
      closed_anomalies_count: 0,
      top_articles: [],
      top_clients: [],
      open_anomalies_over_three_months: [],
      key: 0,
      anomalyList: [],
      charts: {
        anomaly: {
          labels: [
            "Janvier",
            "Février",
            "Mars",
            "Avril",
            "Mai",
            "Juin",
            "Juillet",
            "Août",
            "Septembre",
            "Octobre",
            "Novembre",
            "Décembre",
          ],
          data: [],
          color: "#f96332",
          chartOptions: {
            scales: {
              xAxes: [
                {
                  display: true,
                  scaleLabel: {
                    display: false,
                    labelString: 'Mois',
                  },
                },
              ],
              yAxes: [
                {
                  display: true,
                  scaleLabel: {
                    display: true,
                    labelString: 'Nbre d\'anomalies',
                  },
                  ticks: {
                    min: 0,
                    suggestedMax: 10,
                    stepSize: 1,
                  },
                },
              ],
            },
          }
        },
      },
    };
  },
  mounted() {
    const currentDate = new Date();
    // Récupération des données du rapport des anomalies
    this.axios.get(process.env.VUE_APP_API_BASE_URL + `anomaly/reports`, {
      params: {
        year: currentDate.getFullYear(),
      },
    }).then((response) => {
      this.cost_previous_year = response.data.cost_previous_year;
      this.cost_current_year = response.data.cost_current_year;
      this.open_anomalies_count = response.data.open_anomalies_count;
      this.closed_anomalies_count = response.data.closed_anomalies_count;
      this.top_articles = response.data.top_articles;
      this.top_clients = response.data.top_clients;
      this.open_anomalies_over_three_months = response.data.open_anomalies_over_three_months;
      this.charts.anomaly.data = response.data.anomalies_per_month;
    });
  },
  methods: {
    // Méthode pour formater les dates
    formatDate(dateString) {
      return moment(dateString).format('DD/MM/YYYY');
    },
  },
};
</script>

<style>
.fs-5 {
  font-size: 1.25rem;
}

.card-body p {
  margin-bottom: 0.4rem;
  font-size: 0.85rem;
}

.default-datagrid .e-pager .e-currentitem,
.e-pager .e-currentitem:hover {
  background: #f96332;
  color: #fff;
  opacity: 1;
}

.separator {
  position: absolute;
  top: 0;
  right: 0;
  width: 1px;
  height: 100%;
  background-color: #e0e0e0; /* Couleur du séparateur */
}

.col:not(:last-child) .separator {
  display: block;
}

.col:last-child .separator {
  display: none; /* Pas de séparateur après la dernière colonne */
}
</style>
